let answersEvaluated = new Event('growtypeQuizResultsEvaluated');

export function resultsEvaluatedEvent() {
    return answersEvaluated;
}
